export const SESSION_STORAGE_KEYS = {
  TARGET_LANGUAGES: 'targetLanguages',
  IS_UNPAID_INVOICE_BANNER_DISMISSED: 'isUnpaidInvoiceBannerDismissed',
};

export const sessionStorage = {
  clearAll() {
    window.sessionStorage.clear();
  },

  get(key) {
    const value = window.sessionStorage.getItem(key);
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
      return value;
    }
  },

  set(key, value) {
    if (typeof value === 'object') {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      window.sessionStorage.setItem(key, value);
    }

    window.sessionStorage.setItem(key + ':ts', Date.now());
  },

  remove(key) {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.removeItem(key + ':ts');
  },
};
